import { Component, OnInit, ViewChild, ElementRef, HostListener, Output, EventEmitter } from "@angular/core";
import { PreferenceService } from "../../services/preference.service";
import { NgbModal, NgbCarouselConfig, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DeliveryClosureService } from "../../services/delivery-closure.service";
import { concat, Subscription } from "rxjs"
import {
  FormBuilder,
  FormArray,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import Holidays from "date-holidays";
import * as _ from 'lodash';
import { ThrowStmt } from "@angular/compiler";

const hd = new Holidays();

const currentYear = moment().format("YYYY");
const currentMonth = moment().format("MM");
const yearLimit = parseInt(currentYear) + 3;
const yearStart = parseInt(currentYear) - 1;
const mobileWidth = 600;
const tabletWidth = 1300;
const currentCardHealthHolidays = [
  "New Year's Day",
  "New Year's Day (substitute day)",
  "Martin Luther King Jr. Day",
  "Memorial Day",
  "Independence Day",
  "Labor Day",
  "Thanksgiving Day",
  "Christmas Day",
];

const today = moment();
const lastDayOfPastDays = today.clone().add(10, "days");
const RETAIL_USER = "RETAIL_INDEPENDENT";
const ACUTE_ADMIN =
  "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__ACUTE_CARE__ACUTE_CARE_ORDERING__ADMIN";

@Component({
  selector: "app-delivery-closure-v3",
  templateUrl: "./delivery-closure-v3.component.html",
  styleUrls: ["./delivery-closure-v3.component.sass"],
})
export class DeliveryClosureV3Component implements OnInit {

  clickEventSubscription: Subscription


  @ViewChild("monthsContent", { static: false }) widgetsContent: ElementRef;
  @ViewChild("contentConfirmation", { static: false }) contentConf: ElementRef;
  @ViewChild("contentError", { static: false }) contentErr: ElementRef;
  @ViewChild("contentLocations", { static: false }) contentLocations: ElementRef;



  emailsForm = this.fb.group({
    emails: this.fb.array([this.fb.control("", [Validators.email])]),
  });

  selectMPForm = new FormGroup({
    selectLocations: new FormControl(),
  });

  monthQuarterMap = new Map();
  currentCalendarArray = [] as any;
  calendarArray = [] as any;
  days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  displayPharmacyName;
  displayPharmacyId;

  selectedMonth
  selectedYear
  isFirstMonthOfCalendar: boolean
  errorVariable: boolean = false
  isFirstYearOfCalendar: boolean
  isFinalYearOfCalendar: boolean
  currentDisplayedYear: number
  showMultipleEmails = false
  showNextButton = false
  addingEmail = false
  updateWithEmail: boolean
  hideConfirm: boolean
  displayDateHeader = [] as any
  displayYearSlider = [] as any
  shipTosAcctNumbers = [] as any
  displayDeliveryClosuresByMonth = [] as any
  updatedClosureDates = [] as any
  futureDateArr = [] as any
  isDateSelected = false
  hibeAddEmailBtn = true
  totalAccountPrefClosureDates: string
  startYearCurrentClosureDates: string
  midYearCurrentClosureDates: string
  endYearCurrentClosureDates: string
  splitArray = [] as any

  startingClosuredates;
  msg: string;

  isYearSelected: boolean;

  isLastMonthOfCalendar: boolean;

  updatePharmacyKey;
  updatePharmacyName;

  //TODO
  additionalEmails;

  lastEditedDate;
  lastEditedId;
  displayCurrentDisplayDates;
  updateSessionStorage;
  routeId;

  addedDates = [] as any;
  removedDates = [] as any;
  removedPrefs;
  addedPrefs;
  closureDateArray = [] as any;
  allDatesArray = [] as any;
  futureDaysBlocked: string[] = [];
  currentUserEmail;
  tempVariable
  isUserAdmin;

  inputClosureDates;
  inputAddedDates;
  inputRemovedDates;

  //global variable to capture apiresponse
  apiresponse: boolean = false;

  constructor(
    private prefService: PreferenceService,
    private modalService: NgbModal,
    config: NgbCarouselConfig,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private deliveryClosureService: DeliveryClosureService,
    private router: Router,
    private fb: FormBuilder
  ) {
    config.showNavigationArrows = true;
    config.keyboard = false;
    this.clickEventSubscription = this.prefService.getClickEvent().subscribe(() => {
      this.disableSubmitError()
    })
  }

  ngOnInit(): void {
    //this.tempunction()

    sessionStorage.removeItem("addedDates");

    sessionStorage.removeItem("removedDates");

    this.route.params.subscribe((params) => {
      this.routeId = params["id"];
    });

    if (this.routeId === undefined) {
      sessionStorage.setItem("shiptoIndex", "0");
    } else {
      sessionStorage.setItem("shipToIndex", this.routeId);
    }
    this.selectedYear = parseInt(currentYear);

    // Determine starting month if mobile/tablet/desktop
    const m = parseInt(currentMonth);
    this.selectedMonth = m;
    if (this.isTablet() && m === 12) this.selectedMonth = 11;
    if (!this.isMobile() && !this.isTablet() && m > 10) this.selectedMonth = 10;

    this.currentDisplayedYear = this.selectedYear;
    this.getPreferences(this.selectedYear);

    this.buildUI(this.selectedMonth, this.selectedYear, this.closureDateArray);

    this.selectedYearUI(this.selectedYear);

    this.isFirstMonthOfCalendar = false;
    this.isFirstYearOfCalendar = true;
    this.isFinalYearOfCalendar = false;
    this.isLastMonthOfCalendar = false;
    this.deliveryClosureService.$selectedPharmacy.subscribe((data) => {
      sessionStorage.removeItem(this.selectedYear);
      sessionStorage.setItem("shiptoIndex", data);

      this.getPreferences(this.selectedYear);

      this.buildUI(
        this.selectedMonth,
        this.selectedYear,
        this.closureDateArray
      );
      this.selectedYearUI(this.selectedYear);

      this.displayCurrentPharmacyClosures(this.closureDateArray);



      this.currentUserEmail = this.getUserEmailFromSessionStorage();

    });

    this.currentUserEmail = this.getUserEmailFromSessionStorage();
    this.getToolTipPastToday();
    this.getIsUserAdmin();
    this.getAlldates();

  }

  getAlldates() {
    this.prefService.getAccountPrefs("*").subscribe(
      (data) => {
        for (let i = 0; i < data.accountPreferenceDataList.length; i++) {
          if (data.accountPreferenceDataList[i].removedPreference != "") {
            this.allDatesArray.push(data.accountPreferenceDataList[i].removedPreference)
          }
        }
      }
    )
  }

  createPharmacyStores(storeAccountNumbers) {
    for (let i = 0; i < storeAccountNumbers.shipTos.length; i++) {
      this.shipTosAcctNumbers.push(storeAccountNumbers.shipTos[i].id);
    }
  }

  onSelectLocations() {
    this.showNextButton = true;
  }

  private getIsUserAdmin() {
    let userData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let memberSettings = userData.userSettings.memberGroups;

    let retailUser = memberSettings.filter((s) => s.includes(RETAIL_USER));
    let acuteAdmin = memberSettings.filter((s) => s.includes(ACUTE_ADMIN));

    if (retailUser.length >= 1 || acuteAdmin.length >= 1) {
      this.isUserAdmin = true;
    } else {
      this.isUserAdmin = false;
    }

    return this.isUserAdmin;
  }

  get emails() {
    return this.emailsForm.get("emails") as FormArray;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key == "Escape") {
      this.disableSubmit()
    }
  }
  // ------------------ START API CALLS --------------------------------------

  private getPreferences(selectedYear): any {
    this.totalAccountPrefClosureDates = "";
    this.spinnerService.show();

    this.prefService.getAccountPrefs(selectedYear).subscribe(
      (data) => {

        if (
          data.accountPreferenceDataList == "" ||
          data.accountPreferenceDataList[0].preference.length == 0
        ) {
          this.closureDateArray = "";

        } else {
          if (data.accountPreferenceDataList[0].preference) {
            this.closureDateArray =
              data.accountPreferenceDataList[0].preference;

            this.lastEditedId = data.accountPreferenceDataList[0].lastUpdatedBy;
            let formatedDate = this.convertGMTtoEST(
              data.accountPreferenceDataList[0].lastUpdateTimeStamp
            );
            this.lastEditedDate = this.getParseDate(formatedDate);
          } else {
            this.lastEditedId = "";
            //this.closureDateArray = ''
          }
        }

        if (sessionStorage.getItem(selectedYear)) {
          let dates = sessionStorage.getItem(selectedYear);
          this.closureDateArray = dates;

        }
        sessionStorage.setItem(selectedYear, this.closureDateArray);

        // this.getSessionDatesByYear();
        this.startingClosuredates = this.startingClosuredates != undefined ?
          ((this.startingClosuredates.indexOf(this.closureDateArray) !== -1) ? this.startingClosuredates : (this.startingClosuredates + ',' + this.closureDateArray))
          : this.closureDateArray;

        if (this.removedDates.length) {
          let closeDatesArray = this.closureDateArray.split(",");

          this.removedDates.forEach(date => {
            closeDatesArray = closeDatesArray.filter((m) => m != date);

          });
          this.closureDateArray = closeDatesArray.toString();

        }
        this.displayCurrentDisplayDates = this.closureDateArray;


        this.buildAllUIComponents(
          this.selectedMonth,
          this.selectedYear,
          this.closureDateArray
        );
        this.spinnerService.hide();

      },
      (error) => {


        this.closureDateArray = "";
        this.displayCurrentPharmacyClosures(this.closureDateArray);

        if (this.errorVariable == false) {
          this.modalService.open(this.contentErr);
        }

        sessionStorage.setItem(selectedYear, this.closureDateArray);

        this.startingClosuredates = this.startingClosuredates != undefined ?
          ((this.startingClosuredates.indexOf(this.closureDateArray) !== -1) ? this.startingClosuredates : (this.startingClosuredates + ',' + this.closureDateArray))
          : this.closureDateArray;
        if (this.removedDates.length) {
          let closeDatesArray = this.closureDateArray.split(",");
          this.removedDates.forEach(date => {
            closeDatesArray = closeDatesArray.filter((m) => m != date);
          });
          this.closureDateArray = closeDatesArray.toString();
        }
        this.displayCurrentDisplayDates = this.closureDateArray;

        this.buildAllUIComponents(
          this.selectedMonth,
          this.selectedYear,
          this.closureDateArray
        );
        this.spinnerService.hide();

      }

    );

  }


  updateClosureDatePreferences(dontSubmit) {

    this.updateSessionStorage = sessionStorage.getItem("prefApi");
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let removedDates = this.removedDates;
    let addedDates = this.addedDates;
    let currentUserId = apiData.id;
    let transId = this.generateTransactionId();
    let userId = currentUserId;
    let shipToIndex = sessionStorage.getItem("shiptoIndex");

    let sortedShipTos = JSON.parse(sessionStorage.getItem("sortedShipTos"));

    this.displayPharmacyName = sortedShipTos[shipToIndex].name;
    let keyId =
      sortedShipTos[shipToIndex].dc + "-" + sortedShipTos[shipToIndex].customer;
    this.displayPharmacyId = keyId;
    let key = keyId;
    //Added Friday Night 07/16 -__---------------------------------
    //this.inputClosureDates = this.closureDateArray

    this.updatePharmacyKey = this.displayPharmacyId;
    this.updatePharmacyName = this.displayPharmacyName;

    let keyYears = [];
    let closureDates = "";
    for (let i = 0; i < sessionStorage.length; i++) {
      let key = sessionStorage.key(i);
      let prevYear = new RegExp(
        moment(currentYear).subtract(1, "year").format("yyyy"),
        "ig"
      );

      if (
        key !== "accessToken" &&
        key !== "userDataObject" &&
        key !== "userAPIData" &&
        key !== "shiptoIndex" &&
        key !== "shipToIndex" &&
        key !== "addedDates" &&
        key !== "removedDates" &&
        key !== "sortedShipTos" &&
        !key.startsWith("com.adobe") &&
        !key.match(prevYear) &&
        key
      ) {
        keyYears.push(key);
      }
    }
    for (let j = 0; j < keyYears.length; j++) {
      if (closureDates === "") {
        closureDates += sessionStorage.getItem(keyYears[j]);

      } else {
        closureDates += "," + sessionStorage.getItem(keyYears[j]);


      }
    }
    // this.inputClosureDates = closureDates;
    removedDates = removedDates.map(i => i + ':R');


    this.prefService.getAccountPrefs(this.selectedYear).subscribe(
      (data) => {
        this.allDatesArray = this.allDatesArray.concat(removedDates)
        if (data.accountPreferenceDataList.length > 0 && data.accountPreferenceDataList[0].hasOwnProperty("removedPreference")) {

          closureDates = closureDates.concat(',' + data.accountPreferenceDataList[0].removedPreference)

          closureDates = closureDates.concat(',' + this.allDatesArray.toString())

          this.splitArray = closureDates.split(',')

          let sdate = []
          let rdate = new Set();

          for (let i = 0; i < this.splitArray.length; i++) {
            if (!this.splitArray[i].includes(':R')) {
              sdate.push(this.splitArray[i])

            }
          }

          for (let j = 0; j < this.splitArray.length; j++) {
            if (this.splitArray[j].includes(':R')) {
              rdate.add(this.splitArray[j])
            }
          }

          for (let i = 0; i < sdate.length; i++) {
            for (let j = 0; j < rdate.size; j++) {


              if (rdate.has(sdate[i] + ":R")) {
                rdate.delete(sdate[i] + ":R")
              }

            }
          }

          this.splitArray = ([...sdate, ...rdate])

          closureDates = _.uniq(this.splitArray).toString();

          this.inputClosureDates = closureDates

          // this.inputClosureDates = _.uniq(this.splitArray).toString();    
        } else {

          closureDates = closureDates.concat(',' + this.allDatesArray.toString())

          this.splitArray = closureDates.split(',')

          let sdate = []
          let rdate = new Set();

          for (let i = 0; i < this.splitArray.length; i++) {
            if (!this.splitArray[i].includes(':R')) {
              sdate.push(this.splitArray[i])

            }
          }
          for (let j = 0; j < this.splitArray.length; j++) {
            if (this.splitArray[j].includes(':R')) {
              rdate.add(this.splitArray[j])
            }
          }

          for (let i = 0; i < sdate.length; i++) {
            for (let j = 0; j < rdate.size; j++) {

              if (rdate.has(sdate[i] + ":R")) {
                rdate.delete(sdate[i] + ":R")
              }


            }
          }

          this.splitArray = ([...sdate, ...rdate])

          closureDates = _.uniq(this.splitArray).toString();

          this.inputClosureDates = closureDates
        }

        if (!dontSubmit)
          this.prefService
            .updateAccountPrefs(
              transId,
              userId,
              closureDates,
              key,
              currentYear,
              removedDates,
              addedDates
            )
            .subscribe(
              (response) => {


                this.totalAccountPrefClosureDates = "";
                this.apiresponse = false;
                //set global variable to true if Api response is values updated
                if (response == "Values Updated") {
                  this.apiresponse = true;
                }
                this.displayCurrentDisplayDates = [];
                this.getPreferences(this.selectedYear);


              },
              (error) => {
                this.modalService.open(this.contentErr);
              },
              () => {
                if (this.apiresponse) {
                  this.modalService.open(this.contentConf);

                } else {

                }
              }
            );
      }


    )

  }


  updateClosureDatesWithEmail(currentYear, addEmail) {
    this.updateSessionStorage = sessionStorage.getItem("prefApi");
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let currentUserId = apiData.id;
    let transId = this.generateTransactionId();
    let userId = currentUserId;
    this.addedPrefs = this.addedDates;

    this.removedPrefs = this.removedDates;

    let shiptoIndex = sessionStorage.getItem("shipToIndex");

    if (shiptoIndex === null) {
      shiptoIndex = "0";
    }
    let key = this.displayPharmacyId;
    let keyName = this.displayPharmacyName;
    let firstName = apiData.firstName;
    let email = addEmail;

    this.prefService
      .sendEmailUpdateAccountPrefs(
        transId,
        userId,
        this.addedDates,
        this.removedDates,
        key,
        currentYear,
        keyName,
        firstName,
        email
      )
      .subscribe((response) => {
        // sessionStorage.removeItem('addedDates')
        // sessionStorage.removeItem('removedDates')
      });
  }

  // ------------------ END API CALLS --------------------------------------

  private buildAllUIComponents(month, year, closureDatesArr) {
    let selectedCloseDates = sessionStorage.getItem(year);

    let currentCDatesUsed;
    if (
      selectedCloseDates !== this.startingClosuredates &&
      selectedCloseDates !== null
    ) {
      currentCDatesUsed = selectedCloseDates;

      //this.closureDateArray = selectedCloseDates
    } else {
      currentCDatesUsed = closureDatesArr;

    }
    if (sessionStorage.getItem(year) !== null) {
      //this.closureDateArray = sessionStorage.getItem(year)
      this.currentCalendarArray = this.buildUI(month, year, currentCDatesUsed);

      this.displayCurrentPharmacyClosures(currentCDatesUsed);

      this.displayUpdatedDeliveryClosuresByMonth();
    } else {
      this.currentCalendarArray = this.buildUI(month, year, closureDatesArr);

      this.displayCurrentPharmacyClosures(closureDatesArr);

      this.displayUpdatedDeliveryClosuresByMonth();
    }
  }

  public getClosureDates(content) {
    let shipToNumber;
    let initial_submit = "delivery closure:submit"
    let submit_single = "delivery closure:submit"
    window["pageData"].initial_submit = {
      Name: initial_submit,
    }
    //code to fire the event from adobe side
    window["_satellite"].track("Event-Store-Closure-Global");
    window["_satellite"].track("Event-Store-Closure-Initial-Submit");

    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let userDataObject = JSON.parse(sessionStorage.getItem("userDataObject"));
    let sortedShipTos = JSON.parse(sessionStorage.getItem("sortedShipTos"));
    let shipToIndex = sessionStorage.getItem("shiptoIndex");

    //this.displayPharmacyName = sortedShipTos[shipToIndex].name
    let keyId =
      sortedShipTos[shipToIndex].dc + "-" + sortedShipTos[shipToIndex].customer;
    //this.displayPharmacyId = keyId
    //let key = keyId
    let pharmacyId = keyId;
    let pharmacyAccts = [];

    for (let i = 0; i < sortedShipTos.length; i++) {
      let cId = sortedShipTos[i].dc + "-" + sortedShipTos[i].customer;
      pharmacyAccts.push(cId);
    }
    let currentShipToIndex = pharmacyAccts.indexOf(pharmacyId);

    this.isDateSelected = false;
    this.displayPharmacyName = sortedShipTos[shipToIndex].name;
    this.displayPharmacyId = keyId;
    //this.clearYearSessionStorage()
    let key = keyId;
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
    };

    this.modalService.open(content, ngbModalOptions);

  }

  public getDateId(isSelectedNow: boolean, dateId: string) {
    this.isDateSelected = true;

    if (isSelectedNow === false) {
      if (this.closureDateArray) {

        this.closureDateArray += "," + dateId;

      } else {
        this.closureDateArray += dateId;

      }

      this.addedDates.push(dateId);

    } else {
      this.removedDates.push(dateId);


      let closeDatesArray = this.closureDateArray.split(",");

      let updatedCloseDates = closeDatesArray.filter((m) => m != dateId);

      this.closureDateArray = updatedCloseDates.toString();

    }

    this.inputAddedDates = this.addedDates;

    this.inputRemovedDates = this.removedDates;

    let startDates = this.startingClosuredates.split(",");

    let tmpInputAddedDates = this.addedDates;

    let tmpInputRemovedDates = this.removedDates;


    let isAddedDatesInUpdatedDates = tmpInputAddedDates.filter(
      (date) => !startDates.includes(date)
    );

    let isAddedDatesInRemovedDates = tmpInputAddedDates.filter((date) =>
      tmpInputRemovedDates.includes(date)
    );

    let isRemovedDatesNotInStartDates = tmpInputRemovedDates.filter(
      (date) => !startDates.includes(date)
    );

    if (isRemovedDatesNotInStartDates) {
      for (let i = 0; i < isRemovedDatesNotInStartDates.length; i++) {
        let index = tmpInputRemovedDates.indexOf(
          isRemovedDatesNotInStartDates[i]
        );
        if (index >= 0)
          tmpInputRemovedDates.splice(index, 1);

      }
    } else {
      this.removedDates = tmpInputRemovedDates;

    }

    if (isAddedDatesInUpdatedDates) {

      this.addedDates = tmpInputAddedDates;

    } else {
      for (let i = 0; i < isAddedDatesInUpdatedDates.length; i++) {
        let index = tmpInputAddedDates.indexOf(isAddedDatesInUpdatedDates[i]);
        if (index >= 0)
          tmpInputAddedDates.splice(index, 1);

      }
      this.addedDates = tmpInputAddedDates;

    }
    if (isAddedDatesInRemovedDates) {

      for (let i = 0; i < isAddedDatesInRemovedDates.length; i++) {
        let index = tmpInputAddedDates.indexOf(isAddedDatesInRemovedDates[i]);
        if (index >= 0)
          tmpInputAddedDates.splice(index, 1);

      }

      for (let i = 0; i < isAddedDatesInRemovedDates.length; i++) {
        let index = tmpInputRemovedDates.indexOf(isAddedDatesInRemovedDates[i]);
        if (index >= 0)
          tmpInputRemovedDates.splice(index, 1);

      }

      this.addedDates = tmpInputAddedDates;

      this.removedDates = tmpInputRemovedDates;

    } else {
      this.removedDates = tmpInputRemovedDates;

    }

    if (this.addedDates == "" && this.removedDates == "") {
      this.isDateSelected = false;

    }

    let closureDatesSorted = this.closureDateArray.split(",");

    let clDatesString = closureDatesSorted.sort();

    this.closureDateArray = clDatesString.toString();

    sessionStorage.setItem(this.selectedYear, this.closureDateArray);


    //this.inputClosureDates = this.closureDateArray

    sessionStorage.setItem("addedDates", this.addedDates.toString());
    sessionStorage.setItem("removedDates", this.removedDates.toString());


    this.buildAllUIComponents(
      this.selectedMonth,
      this.selectedYear,
      this.closureDateArray
    );
  }

  public buildUI(selectedMth, selectedYr, currentClosureDates) {
    this.monthQuarterMap.clear();
    this.calendarArray = [];
    this.displayDateHeader = [];

    this.monthQuarterMap = this.buildMonth(selectedMth, parseInt(selectedYr));
    this.monthQuarterMap.forEach((value, key) => {
      this.calendarArray.push(
        this.buildMonthArr(
          key,
          value.days,
          value.start,
          selectedYr,
          currentClosureDates
        )
      );
      this.displayDateHeader.push(key);
    });
    this.monthQuarterMap.clear();
    return this.calendarArray;
  }

  selectedYearUI(year: number) {
    let year1 = year - 1 < yearStart ? yearStart : year - 1;
    let year2 =
      year === year1 ? year1 + 1 : year === yearLimit ? year - 1 : year;
    let year3 = year2 + 1 >= yearLimit ? yearLimit : year + 1;

    if (year1 === year2) year1 -= 1;
    if (year2 === year3) year3 -= 1;
    if (year3 === year1) year3 += 2;

    this.currentDisplayedYear =
      year < yearStart ? yearStart : year > yearLimit ? yearLimit : year;
    this.displayYearSlider = [year1, year2, year3];
    this.isFirstYearOfCalendar = year1 === yearStart;
    this.isFinalYearOfCalendar = year3 === yearLimit;

    return this.displayYearSlider;
  }

  public quickSelectYear(year) {
    this.isFinalYearOfCalendar = false;
    this.isFirstYearOfCalendar = false;
    this.selectedYear = year;

    if (this.displayYearSlider[2] >= yearLimit)
      this.isFinalYearOfCalendar = true;
    if (this.displayYearSlider[0] <= yearStart)
      this.isFirstYearOfCalendar = true;

    this.updateUI();
  }

  getUserEmailFromSessionStorage() {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let emailString = apiData.email;

    return emailString;
  }

  updateUI() {
    const changeOnMonth = this.isMobile() ? 12 : this.isTablet() ? 11 : 10;
    this.isLastMonthOfCalendar = false;
    this.isFirstMonthOfCalendar = false;

    if (this.selectedMonth === 1 && this.selectedYear === yearStart)
      this.isFirstMonthOfCalendar = true;
    if (this.selectedMonth === changeOnMonth && this.selectedYear === yearLimit)
      this.isLastMonthOfCalendar = true;
    this.getPreferences(this.selectedYear);
    this.displayCurrentDisplayDates = "";
  }

  public nextYear() {
    this.selectedYearUI(this.currentDisplayedYear + 1);
  }

  public prevYear() {
    this.selectedYearUI(this.currentDisplayedYear - 1);
  }

  public isMobile = () => window.innerWidth < mobileWidth;
  public isTablet = () => window.innerWidth < tabletWidth && !this.isMobile();

  public nextMonth() {
    const changeOnMonth = this.isMobile() ? 12 : this.isTablet() ? 11 : 10;

    if (this.selectedMonth === changeOnMonth && this.selectedYear < yearLimit) {
      this.selectedMonth = 1;
      this.selectedYear++;
      this.selectedYearUI(this.selectedYear);
    } else if (
      !(this.selectedYear === yearLimit && this.selectedMonth === changeOnMonth)
    ) {
      this.selectedMonth++;
    }

    this.updateUI();
  }

  public prevMonth() {
    const changeToMonth = this.isMobile() ? 12 : this.isTablet() ? 11 : 10;

    if (!(this.selectedYear === yearStart && this.selectedMonth === 1))
      this.selectedMonth--;

    if (this.selectedMonth < 1 && this.selectedYear > yearStart) {
      this.selectedMonth = changeToMonth;
      this.selectedYear--;
      this.selectedYearUI(this.selectedYear);
    }
    this.updateUI();
  }

  updateClosureDates(emails) {
    //trigger email if global variable is true i.e no error in api response

    setTimeout(() => {
      if (this.apiresponse == true && emails.length !== 0) {
        this.updateClosureDatesWithEmail(this.selectedYear, emails);
      }
    }, 5000);
    this.startYearCurrentClosureDates = "";
    this.midYearCurrentClosureDates = "";
    this.endYearCurrentClosureDates = "";
    this.displayUpdatedDeliveryClosuresByMonth();
  }

  public isDateClosed(dateSelected, closureDates) {
    let isClosed;
    if (closureDates.includes(dateSelected)) {
      isClosed = true;
    } else {
      isClosed = false;
    }
    return isClosed;
  }

  getAccountPreferenceClosureDatesForPharmacyAndCAH(closureDateListFromApi) {
    let combinedDates = [];
    if (closureDateListFromApi.accountPreferenceDataList.length > 0) {
      let splitStrOne = closureDateListFromApi.accountPreferenceDataList[0].preference.split(
        ","
      );
      splitStrOne.forEach((date) => {
        combinedDates.push(date);
      });
      return combinedDates.sort();
    }
    this.displayUpdatedDeliveryClosuresByMonth();
    return combinedDates;
  }

  getOrderedCloseureDates(closureDates) {
    let parsedDatesArray = JSON.stringify(closureDates);
    let strArray = parsedDatesArray.split(",");
    return strArray.sort();
  }

  //----------------------------- End UI Month/Year navigation ----------------------

  //----------------------------- Start Action Buttons and Modals ----------------------

  submitClosureDates() {
    let submittedClosureDates = JSON.stringify(this.closureDateArray);
    this.isDateSelected = false;
  }
  reloadCurrentRoute() {
    //this.closureDateArray = ''
    this.displayCurrentDisplayDates = "";
    this.totalAccountPrefClosureDates = "";
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: false }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  public disableSubmit() {
    this.isDateSelected = false;
    this.closureDateArray = "";
    this.totalAccountPrefClosureDates = "";
    this.addedDates = [];
    this.removedDates = [];
    this.inputAddedDates = [];
    this.inputRemovedDates = [];

    sessionStorage.removeItem("addedDates");
    sessionStorage.removeItem("removedDates");
    sessionStorage.setItem(this.selectedYear, this.closureDateArray);

    this.getPreferences(this.selectedYear);
    this.modalService.dismissAll();


  }

  disableSubmitError() {

    this.errorVariable = true

    sessionStorage.removeItem("addedDates");
    sessionStorage.removeItem("removedDates");
    this.getPreferences(this.selectedYear);
    this.modalService.dismissAll();
  }




  datesSubmitted() {
    this.modalService.dismissAll();
    this.addedDates = [];
    this.removedDates = [];
    this.emailsForm.reset("emails");
    this.emailsForm = this.fb.group({
      emails: this.fb.array([], [Validators.email]),
    });

    sessionStorage.removeItem("addedDates");
    sessionStorage.removeItem("removedDates");
  }

  public nextModal() {
    let shipToIndex = sessionStorage.getItem("shiptoIndex");
    let sortedShipTos = JSON.parse(sessionStorage.getItem("sortedShipTos"));
    let acctNum = sortedShipTos[shipToIndex].customer;
    let dates: Array<string> = [];
    for (let i = 0; i < this.addedDates.length; i++) {
      let x = acctNum + ":" + this.addedDates[i];
      dates.push(x);
    }
    for (let i = 0; i < this.removedDates.length; i++) {
      let x = acctNum + ":" + this.removedDates[i] + ":R";
      dates.push(x);

    }
    let selected = this.selectMPForm.value;
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
    };

    if (selected.selectLocations === "yes") {
      this.showNextButton = true;
      this.updateWithEmail = false;
      this.modalService.open(this.contentLocations, ngbModalOptions);
      this.updateClosureDatesSubmitDatesBtn(true);
      this.resetForm();
      this.addedDates = [];
      this.removedDates = [];

      //code for submit_multi
      let submit_Multi = 'delivery closure:next'
      window["pageData"].submit_Multi = {
        Name: submit_Multi,
      }
      //code to fire the event from adobe side
      window["_satellite"].track("Event-Store-Closure-Global");
      window["_satellite"].track("Event-Store-Closure-Submit-Multi");
    } else {
      this.showNextButton = true;
      this.updateWithEmail = true;
      this.updateClosureDatesSubmitDatesBtn(false);
      this.modalService.dismissAll();
      // this.modalService.open(this.contentConf);
      this.resetForm();
      //this.clearYearSessionStorage()

      this.closureDateArray = "";
      window["pageData"].submit_single = {
        Name: 'delivery closure:submit single',
        dates: dates
      };
      window["_satellite"].track("Event-Store-Closure-Global");
      window["_satellite"].track("Event-Store-Closure-Single-Submit");
    }
  }

  public resetForm() {
    this.selectMPForm.reset();
    this.selectMPForm.markAsPristine();
    this.selectMPForm.markAsUntouched();
  }

  addEmail() {
    this.emails.push(this.fb.control(""));
  }

  addEmailBtn() {
    this.hibeAddEmailBtn = false;
    this.addingEmail = true;
    this.hideConfirm = true;
  }

  updateClosureDatesSubmitDatesBtn(dontSubmit) {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let email;
    if (apiData.email !== "chris.donovan@cardinalhealth.com") {
      email = apiData.email;
    } else {
      email = "edmccormic@gmail.com";
    }
    if (this.updateWithEmail === true) {
      this.updateClosureDates(email);
    }

    this.updateClosureDatePreferences(dontSubmit);
    this.startYearCurrentClosureDates = "";
    this.midYearCurrentClosureDates = "";
    this.endYearCurrentClosureDates = "";
    this.showNextButton = false;
  }

  updatePharmacyClosureDates(emails) {
    let emailStr = emails.join();
    this.updateClosureDatesWithEmail(this.selectedYear, emailStr);

    let submit = false;
    this.emailsForm.reset();

    this.emailsForm = this.fb.group({
      emails: this.fb.array([], [Validators.email]),
    });

    this.emailsForm.markAsPristine();
    this.emailsForm.markAsUntouched();
    this.hideConfirm = false;
    this.addingEmail = true;
    this.addedDates = [];
    this.removedDates = [];
    //sessionStorage.removeItem("addedDates")
    //sessionStorage.removeItem("removedDates")
    //this.clearYearSessionStorage()
    this.modalService.dismissAll();
  }
  noEmailWithAcct(additionalEmails) {
    this.updateClosureDatesWithEmail(this.selectedYear, additionalEmails);
    let submit = false;
    this.modalService.dismissAll();
  }

  //----------------------------- End Action Buttons and Modals ----------------------

  //----------------------------- Start Tooltips ----------------------

  getToolTipPastToday() {
    this.futureDateArr = new Array(13);

    let today = new Date();
    const options = { month: "2-digit", day: "2-digit", year: "long" };
    let todaysDate = today.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    for (let i = 0; i < this.futureDateArr.length; i++) {
      let cToday = new Date(todaysDate);
      let options1 = { month: "2-digit", day: "2-digit", year: "numeric" };
      let cDay = cToday.setDate(today.getDate() + i + 1);
      let nDay = new Date(cDay);

      this.futureDateArr[i] = nDay.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    }
    return this.futureDateArr;
  }

  getTooltipText(
    isPast: boolean,
    isDefault: boolean,
    isToday: boolean,
    dateKey: string
  ) {
    let isPastTodaysDate = this.futureDateArr.includes(dateKey);
    let holidayStr = dateKey.slice(0, 5);

    let currentHolidays = currentCardHealthHolidays;

    let holiDayTextArr = [
      "New Year's Day: Cardinal Health non-delivery holiday.",
      "New Year's Day (substitute day): Cardinal Health non-delivery holiday.",
      //"Martin Luther King Jr. Day: Cardinal Health non-delivery holiday.",
      "Memorial Day: Cardinal Health non-delivery holiday.",
      "Independence Day: Cardinal Health non-delivery holiday.",
      "Labor Day: Cardinal Health non-delivery holiday.",
      "Thanksgiving: Cardinal Health non-delivery holiday.",
      "Christmas Day: Cardinal Health non-delivery holiday.",
    ];

    var text: string = "";

    var holidayText = "Cardinal Health weekly non-delivery day.";

    if (isToday) {
      text = "Today's date. Please select an available closure date.";
    } else if (isPast && isDefault) {
      text = holidayText;
    } else if (isPast && !isPastTodaysDate) {
      text = "This date has passed. Please select an available closure date.";
    } else if (isDefault) {
      switch (holidayStr) {
        case "01/01":
          text = holiDayTextArr[0];
          break;
        case currentHolidays[1].slice(0, 5):
          text = holiDayTextArr[1];
          break;
        case "01/16":
          text = holiDayTextArr[2];
          break;
        case "07/04":
          text = holidayText;
          break;
        case "05/29":
          text = holidayText;
          break;
        // case currentHolidays[3].slice(0, 5):
        //   text = holiDayTextArr[3];
        //   break;
        // case currentHolidays[4].slice(0, 5):
        //   text = holiDayTextArr[4];
        //   break;
        case "12/25":
          text = holidayText;
          break;
        default:
          text = "Cardinal Health weekly non-delivery day.";
      }
    } else if (isPastTodaysDate) {
      text =
        "The closure deadline has passed. Please contact Customer Service at 800.926.3161 to make changes.";
    }
    if (!this.isUserAdmin) {
      text =
        "Your access rights do not permit you to make any changes. Please contact Customer Service at 800.926.3161 to make changes.";
    }

    return text;
  }

  getTooltipPlacement(dayOfWeek: string, dateNumber: number) {
    var placement: string = "auto";

    // if (dayOfWeek === 'SUN' || dayOfWeek === 'MON') {
    //   placement = 'right'
    // } else if (dayOfWeek === 'SAT') {
    //   placement = 'left'
    // } else if (dateNumber <= 7) {
    //   placement = 'bottom'
    // }

    if (dayOfWeek === "Sun" || dayOfWeek === "Mon") {
      placement = "right";
    } else if (dayOfWeek === "Sat") {
      placement = "left";
    } else if (dateNumber <= 7) {
      placement = "bottom";
    }

    return placement;
  }

  //----------------------------- END TOOLTIPS  ----------------------

  public buildMonth(selectedMonth, selectedYear) {
    let dateObject = moment().set({
      year: parseInt(selectedYear),
      month: selectedMonth,
    });
    let quarterMap = new Map();

    const curDO = dateObject.format("MM");
    const curDaysInMonth = dateObject.daysInMonth();
    const curStartDay = dateObject.startOf("month").day();

    const nextDO = dateObject.add(1, "month").format("MM");
    const nextDaysInMonth = dateObject.daysInMonth();
    const nextStartDay = dateObject.startOf("month").day();

    const prevDO = dateObject.subtract(2, "month").format("MM");
    const prevDaysInMonth = dateObject.daysInMonth();
    const prevStartDay = dateObject.startOf("month").day();

    quarterMap.set(prevDO, { days: prevDaysInMonth, start: prevStartDay });
    quarterMap.set(curDO, { days: curDaysInMonth, start: curStartDay });
    quarterMap.set(nextDO, { days: nextDaysInMonth, start: nextStartDay });

    return quarterMap;
  }

  buildMonthArr(month, numOfDays, startDay, year, currentClosureDates) {
    let monthArray = [] as any;
    let day = {} as any;
    let noDate = {
      dateKey: "00/00/00",
      dateNumber: "0",
      dayOfWeek: "",
      isSelected: false,
      isPast: false,
      isDefault: false,
    };
    for (let i = 0; i < numOfDays; i++) {
      let dayNumStr = i + 1 < 10 ? "" + (i + 1).toString() : (i + 1).toString();
      let dateNumberStr = dayNumStr.length < 2 ? "0" + dayNumStr : dayNumStr;
      let fullDateStr = month + "/" + dateNumberStr + "/" + year;
      day = {
        dateKey: fullDateStr,
        dateNumber: dayNumStr,
        dayOfWeek: this.getDayOfWeek(fullDateStr),
        isSelected: this.getIsSelected(fullDateStr, currentClosureDates),
        isPast: this.getIsPast(fullDateStr),
        isDefault: this.getIsDefault(fullDateStr),
      };

      monthArray.push(day);
    }
    if (monthArray[0].dateNumber === "1") {
      let numberOfDaysToAdd = startDay;
      for (let k = 0; k < numberOfDaysToAdd; k++) {
        monthArray.unshift(noDate);
      }
    }
    let endMth = 42 - monthArray.length;
    for (let l = 0; l < endMth; l++) {
      monthArray.push(noDate);
    }
    const [list, chunkSize] = [monthArray, 7];
    let newMonthArray = [
      ...Array(Math.ceil(list.length / chunkSize)),
    ].map((_) => list.splice(0, chunkSize));

    return newMonthArray;
  }

  public getIsSelected(dateStr, closureDates) {
    const splitCDates = closureDates;

    return splitCDates.includes(dateStr);
  }

  private getDayOfWeek(dateStr) {
    const date = this.formatDateForMoment(dateStr);
    const myObj = moment(date);
    const dayOfWeek = myObj.format("ddd");
    return dayOfWeek;
  }

  private getIsPast(dateStr) {
    let isPast = false;
    const date = moment(dateStr);
    if (date.isBefore(today)) return true;
    if (date.isAfter(lastDayOfPastDays)) return;
    const isFutureWeekend = [0, 6].includes(date.day());

    if (
      this.futureDaysBlocked.length !== 5 &&
      !this.futureDaysBlocked.includes(dateStr)
    ) {
      isPast = true;

      if (isFutureWeekend) isPast = false;
      if (this.getHolidays(dateStr)) isPast = false;

      if (isPast) this.futureDaysBlocked.push(dateStr);
    } else if (this.futureDaysBlocked.includes(dateStr)) isPast = true;

    return isPast;
  }

  private getIsDefault(dateStr) {
    let isDefault =
      this.getDayOfWeek(dateStr) === "Sat" ||
        this.getDayOfWeek(dateStr) === "Sun" ||
        this.getHolidays(dateStr)
        ? true
        : false;
    return isDefault;
  }
  private formatDateForMoment(dateStr) {
    const subDates = dateStr.split("/");
    return subDates[2] + "-" + subDates[0] + "-" + subDates[1];
  }

  private getHolidays(dateStr) {
    hd.init("US");
    const date = this.formatDateForMoment(dateStr) + " 00:00:00";
    let isHoliday = hd.isHoliday(date);
    let isChHoliday;
    if (isHoliday) {
      isChHoliday = currentCardHealthHolidays.includes(isHoliday[0].name);
    } else {
      isChHoliday = false;
    }
    return isChHoliday;
  }

  displayCurrentPharmacyClosures(updatedClosureDates) {
    let dayClosure = {};

    let splitDates = updatedClosureDates.split(",");

    this.updatedClosureDates = [];
    //this.updatedClosureDates = updatedClosureDates.split(",")

    for (let i = 0; i < splitDates.length; i++) {
      let tmpDay = splitDates[i];
      let dateStr = tmpDay.split("/");
      let month = dateStr[0];
      let dayNumStr = dateStr[1];
      let year = dateStr[2];

      dayClosure = {
        dateKey: splitDates[i],
        dateNumber: dayNumStr,
        dayOfWeek: this.getDayOfWeek(splitDates[i]),
        isSelected: this.getIsSelected(splitDates[i], this.closureDateArray),
        isPast: this.getIsPast(splitDates[i]),
        isDefault: this.getIsDefault(splitDates[i]),
      };
      this.updatedClosureDates.push(dayClosure);
    }

    return this.updatedClosureDates;
  }

  displayUpdatedDeliveryClosuresByMonth() {
    let jan = [],
      feb = [],
      mar = [],
      apr = [],
      may = [],
      jun = [],
      jul = [],
      aug = [],
      sep = [],
      oct = [],
      nov = [],
      dec = [];

    let currentClosuresObj = this.displayCurrentPharmacyClosures(
      this.closureDateArray
    );

    currentClosuresObj.forEach((day) => {
      let month = day.dateKey.split("/")[0];
      switch (month) {
        case "01":
          jan.push(day);
          break;
        case "02":
          feb.push(day);
          break;
        case "03":
          mar.push(day);
          break;
        case "04":
          apr.push(day);
          break;
        case "05":
          may.push(day);
          break;
        case "06":
          jun.push(day);
          break;
        case "07":
          jul.push(day);
          break;
        case "08":
          aug.push(day);
          break;
        case "09":
          sep.push(day);
          break;
        case "10":
          oct.push(day);
          break;
        case "11":
          nov.push(day);
          break;
        case "12":
          dec.push(day);
          break;
      }
    });
    this.displayDeliveryClosuresByMonth = [
      jan,
      feb,
      mar,
      apr,
      may,
      jun,
      jul,
      aug,
      sep,
      oct,
      nov,
      dec,
    ];

    return this.displayDeliveryClosuresByMonth;
  }

  public convertGMTtoEST(lastEditedDate) {
    let date, estDate, tmpDate, convertedDate;
    date = new Date(lastEditedDate);
    estDate = date.setHours(date.getHours() - 4);
    tmpDate = new Date(estDate);
    let mm = tmpDate.getMonth() + 1;
    let dd = tmpDate.getDate();
    let yy = tmpDate.getFullYear();

    if (mm.toString().length === 1) {
      mm = "0" + mm;
    }

    if (dd.toString().length === 1) {
      dd = "0" + dd;
    }

    convertedDate = mm + "/" + dd + "/" + yy;

    return convertedDate;
  }

  public getParseDate(lastEditedDate) {
    let formattedDate = "";
    let cDate = lastEditedDate.split("/");
    let momentDate = cDate[0] + "-" + cDate[0] + "-" + cDate[1];
    let month = moment(momentDate).format("MMM");
    let day = lastEditedDate.slice(3, 5);

    let year = lastEditedDate.slice(6, 10);

    formattedDate = month + " " + day + ", " + year;
    return formattedDate;
  }

  public generateTransactionId() {
    let transactionId =
      "account-" +
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    return transactionId;
  }

  MPUpdated(input) {
    if (input) {
      this.inputClosureDates = "";
      this.getPreferences(this.selectedYear);
      this.buildUI(
        this.selectedMonth,
        this.selectedYear,
        this.closureDateArray
      );
      //this.clearYearSessionStorage()
    }
  }

  getSessionDatesByYear() {
    let closeDatesArray = [];
    let startYear = parseInt(currentYear) - 1;

    for (let i = 0; i < 6; i++) {
      startYear++;

      if (sessionStorage.getItem(startYear.toString())) {
        closeDatesArray[i] = sessionStorage.getItem(startYear.toString());

      }
    }

    let yearStrArray = [];

    closeDatesArray.forEach((dateStr) => {
      let dateStrArray = dateStr.split(",");
      let year = dateStrArray[0].split("/")[2];
      yearStrArray.push(year);
    });

    let curAddedDates = sessionStorage.getItem("addedDates");
    let curRemovedDates = sessionStorage.getItem("removedDates");

    let addedYrsArr = [];
    let removedYrsArr = [];
    let removedDatesArr;
    let addedDatesArr;
    if (curAddedDates) {
      addedDatesArr = curAddedDates.split(",");
      addedDatesArr.forEach((date) => {
        let dateStrArray = date.split(",");
        let year = dateStrArray[0].split("/")[2];
        addedYrsArr.push(year);
      });
    }
    if (curRemovedDates) {

      removedDatesArr = curRemovedDates.split(",");

      removedDatesArr.forEach((date) => {
        let dateStrArray = date.split(",");
        let year = dateStrArray[0].split("/")[2];
        removedYrsArr.push(year);

      });
    }
    let uniqueAddDates = [...new Set(addedYrsArr)];
    let uniqueRemoveDates = [...new Set(removedYrsArr)];

    let isAddedDatesInUniqueAddDates = yearStrArray.filter(
      (date) => !uniqueAddDates.includes(date)
    );
    let isAddedDatesInUniqueRemoveDates = yearStrArray.filter(
      (date) => !uniqueRemoveDates.includes(date)
    );
    let combineAddAndRemoveDates = [
      ...new Set(
        isAddedDatesInUniqueAddDates.concat(isAddedDatesInUniqueRemoveDates)
      ),
    ];

    if (combineAddAndRemoveDates.length > 0) {
      isAddedDatesInUniqueAddDates.forEach((year) => {
        sessionStorage.removeItem(year);
      });
    }
  }

  getCurrentClosureDates() {
    let keyYears = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      let key = sessionStorage.key(i);
      if (
        key !== "accessToken" &&
        key !== "userDataObject" &&
        key !== "userAPIData" &&
        key !== "shiptoIndex" &&
        key !== "shipToIndex" &&
        !key.startsWith("com.adobe")
      ) {
        keyYears.push(key);
      }
    }
  }

  removeYearSessionStorage() {
    for (let i = 0; i < sessionStorage.length; i++) {
      let key = sessionStorage.key(i);
      if (
        key !== "accessToken" &&
        key !== "userDataObject" &&
        key !== "userAPIData" &&
        key !== "shiptoIndex" &&
        key !== "shipToIndex" &&
        !key.startsWith("com.adobe")
      ) {
        sessionStorage.removeItem(key);
      }
    }
  }
}
